<template>
    <div class="pcat-page">
        <div class="content_outer">
            <div class="content_inner">
                <div class="pcat-page__sidebar-col">
                    <div
                        id="MainSubmainContent"
                        class="pcat-page__sidebar-shell"
                    >
                        <!-- 產品大類中類清單 -->
                        <div class="pcat-page__sidebar-panel">
                            <gh-sidebar
                                class="pcat-page__sidebar"
                                :items="classificationSidebarItems"
                                :active-id="classificationSidebarActiveId"
                                :active-level="classificationSidebarActiveLevel"
                                :show-arrow="false"
                                :auto-scroll-active="true"
                                :active-scroll-behavior="
                                    ScrollBehaviorMode.Smooth
                                "
                                :active-scroll-position="
                                    SidebarActiveScrollPosition.Center
                                "
                                :collapsible="false"
                                @change-item="handleClassificationSidebarChange"
                            ></gh-sidebar>
                        </div>

                        <!-- 其他功能連結 -->
                        <ul class="pcat-page__links">
                            <li>
                                <a href="/Home/Download">版型/刀模下載</a>
                            </li>
                            <li
                                v-if="
                                    urlQueryString.superClassID !==
                                    'PostProcessing'
                                "
                            >
                                <a
                                    href="/ProductCategory/ProductsClassification/PostProcessing"
                                >
                                    後加工選項說明
                                </a>
                            </li>
                            <li>
                                <a href="/Home/faq?b=a03&c=faqcolor_3">
                                    完稿須知
                                </a>
                            </li>
                            <li>
                                <a href="/Home/App">APP下載</a>
                            </li>
                            <li>
                                <a href="/Account/NoviceOrderProcess">
                                    訂購流程
                                </a>
                            </li>
                            <li>
                                <a
                                    href="/CoEditionUpload/CoEditionOrderV2?MainClassID=Sample&SubMainClassID=Sample01&ProductClassID=ReadyProductPatternEdition"
                                >
                                    購買紙樣
                                </a>
                            </li>
                        </ul>
                    </div>
                </div>

                <div class="pcat-page__content-col">
                    <!-- Banner Area -->
                    <div class="pcat-page__banner">
                        <div id="ProductBanner" class="pcat-page__banner-media">
                            <img
                                v-if="mainClassBannerImage"
                                v-lazy-img="{
                                    src:
                                        '/Images/ProductsClassification/ProductBanner/' +
                                        mainClassBannerImage,
                                    tag: 'product-banner-web',
                                    loading: 'eager',
                                    fetchPriority: 'high',
                                }"
                                width="1332"
                                height="456"
                                :alt="currentMainClassTitle"
                            />

                            <div class="pcat-page__banner-card">
                                <div class="pcat-page__banner-body">
                                    <h1 class="pcat-page__banner-title">
                                        {{ currentMainClassTitle }}
                                    </h1>
                                    <p class="pcat-page__banner-desc none500">
                                        {{ currentMainClassDesc }}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 導覽 與 排列 -->
                    <div id="NavViewsContent" class="pcat-page__nav">
                        <gh-breadcrumb
                            class="pcat-page__breadcrumb"
                            :node-list="breadcrumbNodes"
                        ></gh-breadcrumb>
                        <div class="pcat-page__layout">
                            <template v-if="!isPrinting">
                                <div
                                    :class="[
                                        'pcat-page__layout-btn',
                                        currentMode === LAYOUT_MODE.GRID
                                            ? 'is-current'
                                            : '',
                                    ]"
                                    @click="BrowseModeChange(LAYOUT_MODE.GRID)"
                                >
                                    <svg-icon
                                        class="pcat-page__icon"
                                        icon-name="grid-regular"
                                    ></svg-icon>
                                    <span>圖示排列</span>
                                </div>
                                <div
                                    :class="[
                                        'pcat-page__layout-btn',
                                        currentMode === LAYOUT_MODE.LIST
                                            ? 'is-current'
                                            : '',
                                    ]"
                                    @click="BrowseModeChange(LAYOUT_MODE.LIST)"
                                >
                                    <svg-icon
                                        class="pcat-page__icon"
                                        icon-name="list-regular"
                                    ></svg-icon>
                                    <span>列表排列</span>
                                </div>
                                <div class="pcat-page__layout-separator"></div>
                                <div
                                    class="pcat-page__layout-btn pcat-page__layout-btn--auto"
                                    :class="{ BtnShowMember: !isAuthorized }"
                                    @click="
                                        isAuthorized ? TogglePrintMode() : null
                                    "
                                >
                                    <svg-icon
                                        class="pcat-page__icon"
                                        icon-name="printer-regular"
                                    ></svg-icon>
                                    <span>列印商品清單</span>
                                </div>
                            </template>
                            <template v-else>
                                <div
                                    class="btn btn-white-086efb"
                                    :class="{ active: selectAllActiveFlag }"
                                    :style="btnStyle"
                                    @click="AddAllPrintItem(productSubMains)"
                                >
                                    <span>全選</span>
                                </div>
                                <div
                                    class="btn btn-white-086efb"
                                    :class="{ active: selectNoneActiveFlag }"
                                    :style="btnStyle"
                                    @click="RemoveAllPrintItem"
                                >
                                    <span>取消選取</span>
                                </div>
                                <div
                                    class="btn btn-white-086efb"
                                    :style="[btnStyle, { padding: '9px' }]"
                                    @click="TogglePrintMode"
                                >
                                    <img
                                        :src="'/Content/.theme/.base/img/header/close.svg'"
                                    />
                                </div>
                            </template>
                        </div>
                    </div>

                    <!-- 產品大類底下，各個中類 -->
                    <div id="productBoxs" class="pcat-page__sections">
                        <!-- 產品中類→小類 顯示區塊 -->
                        <div
                            v-for="(subMainClass, index) in productSubMains"
                            :id="'SubMainArea_' + subMainClass.SubMainClassID"
                            :key="subMainClass.SubMainClassID"
                            class="pcat-page__section pcat-page__section-anchor"
                            :data-sub-main-class-id="
                                subMainClass.SubMainClassID
                            "
                        >
                            <!-- 產品中類名稱 -->
                            <div class="pcat-page__section-head">
                                <h2 class="pcat-page__section-title">
                                    <span class="pcat-page__section-code">
                                        {{ subMainClass.ProductCode }}
                                    </span>
                                    <span class="pcat-page__section-name">
                                        {{ subMainClass.SubMainClassName }}
                                    </span>
                                </h2>

                                <div class="pcat-page__section-actions">
                                    <a
                                        v-if="
                                            [
                                                '100101',
                                                '100201',
                                                '100202',
                                            ].includes(subMainClass.ProductCode)
                                        "
                                        class="pcat-page__sub-btn"
                                        :href="goCalendar()"
                                        target="_blank"
                                    >
                                        <svg-icon
                                            class="pcat-page__icon"
                                            icon-name="picture-regular"
                                        ></svg-icon>
                                        <span>瀏覽圖庫</span>
                                    </a>
                                    <a
                                        v-if="
                                            subMainClass.DownloadURL &&
                                            subMainClass.DownloadURL.trim() !==
                                                ''
                                        "
                                        class="pcat-page__sub-btn"
                                        :href="subMainClass.DownloadURL.trim()"
                                    >
                                        <svg-icon
                                            class="pcat-page__icon"
                                            icon-name="download-regular"
                                        ></svg-icon>
                                        <span>版型/刀模下載</span>
                                    </a>
                                    <button
                                        v-if="
                                            subMainClass.SpecImage &&
                                            subMainClass.SpecImage.trim() !== ''
                                        "
                                        type="button"
                                        class="pcat-page__sub-btn"
                                        :data-dialog-id="
                                            'dialog-' +
                                            subMainClass.SubMainClassID
                                        "
                                        @click="showSubMainSpec(index)"
                                    >
                                        <svg-icon
                                            class="pcat-page__icon"
                                            icon-name="ruler-regular"
                                        ></svg-icon>
                                        <span>查看尺寸規格</span>
                                    </button>
                                    <a
                                        v-if="
                                            isPostProcessing &&
                                            getSubMainPricingImages(
                                                subMainClass
                                            ).length > 0
                                        "
                                        class="pcat-page__sub-btn"
                                        @click="showSubMainPrice(index)"
                                    >
                                        <svg-icon
                                            class="pcat-page__icon"
                                            icon-name="trade-dollar-regular"
                                        ></svg-icon>
                                        <span>查看價格表</span>
                                    </a>
                                </div>
                            </div>

                            <!-- 隱藏的彈窗內容(尺寸規格) -->
                            <gh-modal
                                :ref="getSpecModalRefSetter(index)"
                                class="spec-modal"
                            >
                                <div style="justify-self: center">
                                    <img
                                        v-lazy-img="
                                            '/Images/ProductsClassification/ProductSpec/' +
                                            (subMainClass.SpecImage
                                                ? subMainClass.SpecImage
                                                : 'default_spec.jpg')
                                        "
                                        alt="尺寸規格"
                                    />
                                </div>
                            </gh-modal>
                            <!-- 價格表彈窗 -->
                            <gh-modal
                                :ref="getPriceModalRefSetter(index)"
                                class="price-modal"
                            >
                                <div>
                                    <template
                                        v-if="
                                            getSubMainPricingImages(
                                                subMainClass
                                            ).length === 0
                                        "
                                    >
                                        <img
                                            :src="'/Images/ProductsClassification/ProductPrice/default_price.jpg'"
                                            alt="價格表"
                                        />
                                    </template>
                                    <template v-else>
                                        <img
                                            v-for="(
                                                priceImg, priceIndex
                                            ) in getSubMainPricingImages(
                                                subMainClass
                                            )"
                                            :key="priceIndex"
                                            :src="
                                                '/Images/ProductsClassification/ProductPrice/' +
                                                priceImg
                                            "
                                            alt="價格表"
                                        />
                                    </template>
                                </div>
                            </gh-modal>

                            <!-- 產品小類清單 -->
                            <div
                                :class="[
                                    'pcat-page__products',
                                    'pcat-page__products--' + currentMode,
                                ]"
                            >
                                <product-card
                                    v-for="(
                                        productClass, productClassIndex
                                    ) in subMainClass.ProductClassList"
                                    :id="
                                        'ProductInfoBox_' +
                                        productClass.ProductClassID
                                    "
                                    :key="
                                        'product-card-' +
                                        productClass.ProductClassID +
                                        '-' +
                                        productClassIndex
                                    "
                                    :product-id="productClass.ProductClassID"
                                    :product-name="
                                        productClass.ProductClassName
                                    "
                                    :product-code="productClass.ProductCode"
                                    :product-type="productClass.Type"
                                    :product-main-image="productClass.ImgUrl"
                                    :product-images="productClass.ImgDetailUrl"
                                    :product-image-alt="
                                        productClass.ProductClassName
                                    "
                                    :product-desc="productClass.Description"
                                    :product-process-time="
                                        productClass.ProcessTime
                                    "
                                    :layout-mode="currentMode"
                                    :image-mode="IMAGE_MODE.SLIDESHOW"
                                    lazy-tag="product-card-thumb"
                                    :show-overlay="true"
                                    :is-post-processing="isPostProcessing"
                                    :is-printing="isPrinting"
                                    :is-print-items-exists="
                                        IsPrintItemsExists(productClass)
                                    "
                                    @toggle-print-item="
                                        TogglePrintItem(productClass)
                                    "
                                    @click="
                                        !isPrinting &&
                                        getProductExceptionItem(
                                            productClass.Type
                                        )
                                            ? goDetail(
                                                  productClass.ProductClassID
                                              )
                                            : null
                                    "
                                >
                                    <template #product-price>
                                        <div class="pcat-page__price-grid">
                                            <template
                                                v-if="
                                                    getProductExceptionItem(
                                                        productClass.Type
                                                    )
                                                "
                                            >
                                                <span
                                                    class="pcat-page__unit-num"
                                                >
                                                    {{
                                                        getProductExceptionItem(
                                                            productClass.Type
                                                        )?.qty
                                                    }}
                                                </span>
                                                <span class="pcat-page__unit">
                                                    {{
                                                        getProductExceptionItem(
                                                            productClass.Type
                                                        )?.unit
                                                    }}
                                                </span>
                                                起印・
                                                <span>
                                                    {{
                                                        getProductExceptionItem(
                                                            productClass.Type
                                                        )?.price
                                                    }}
                                                </span>
                                            </template>
                                            <template v-else>
                                                <span
                                                    class="pcat-page__unit-num"
                                                >
                                                    {{
                                                        formattedNumber(
                                                            productClass.MinOrderQty
                                                        )
                                                    }}
                                                </span>
                                                <span class="pcat-page__unit">
                                                    {{ productClass.Unit }}
                                                </span>
                                                起印・$
                                                <span class="pcat-page__price">
                                                    {{
                                                        formattedPrice(
                                                            productClass.Price
                                                        )
                                                    }}
                                                </span>
                                            </template>
                                        </div>

                                        <div class="pcat-page__price-list">
                                            <template
                                                v-if="
                                                    getProductExceptionItem(
                                                        productClass.Type
                                                    )
                                                "
                                            >
                                                <span
                                                    class="pcat-page__unit-num"
                                                >
                                                    {{
                                                        getProductExceptionItem(
                                                            productClass.Type
                                                        )?.qty
                                                    }}
                                                </span>
                                                <span class="pcat-page__unit">
                                                    {{
                                                        getProductExceptionItem(
                                                            productClass.Type
                                                        )?.unit
                                                    }}起印&nbsp;&nbsp;&nbsp;
                                                </span>
                                                <span>
                                                    {{
                                                        getProductExceptionItem(
                                                            productClass.Type
                                                        )?.price
                                                    }}
                                                </span>
                                            </template>
                                            <template
                                                v-else-if="
                                                    (productClass.STotalPrice ||
                                                        0) > 0 &&
                                                    (productClass.DTotalPrice ||
                                                        0) > 0
                                                "
                                            >
                                                <span>
                                                    單面 $
                                                    <span
                                                        class="pcat-page__price"
                                                    >
                                                        {{
                                                            formattedPrice(
                                                                productClass.STotalPrice
                                                            )
                                                        }}
                                                    </span>
                                                    &nbsp;&nbsp;&nbsp;
                                                </span>
                                                <span>
                                                    雙面 $
                                                    <span
                                                        class="pcat-page__price"
                                                    >
                                                        {{
                                                            formattedPrice(
                                                                productClass.DTotalPrice
                                                            )
                                                        }}
                                                    </span>
                                                    &nbsp;&nbsp;&nbsp;
                                                </span>
                                                <span
                                                    class="pcat-page__unit-num"
                                                >
                                                    {{
                                                        formattedNumber(
                                                            productClass.MinOrderQty
                                                        )
                                                    }}
                                                </span>
                                                <span class="pcat-page__unit">
                                                    {{ productClass.Unit }}
                                                </span>
                                                起印
                                            </template>
                                            <template v-else>
                                                <span>
                                                    售價 $
                                                    <span
                                                        class="pcat-page__price"
                                                    >
                                                        {{
                                                            formattedPrice(
                                                                productClass.Price
                                                            )
                                                        }}
                                                    </span>
                                                    &nbsp;&nbsp;&nbsp;
                                                </span>
                                                <span
                                                    class="pcat-page__unit-num"
                                                >
                                                    {{
                                                        formattedNumber(
                                                            productClass.MinOrderQty
                                                        )
                                                    }}
                                                </span>
                                                <span class="pcat-page__unit">
                                                    {{ productClass.Unit }}
                                                </span>
                                                起印
                                            </template>
                                        </div>
                                    </template>
                                    <template #grid-overlay>
                                        <!-- 產品描述 -->
                                        <div
                                            v-if="
                                                currentMode === LAYOUT_MODE.GRID
                                            "
                                            class="pcat-page__card-detail"
                                        >
                                            <div
                                                v-if="
                                                    productClass.ImgDetailUrl
                                                        .length === 0
                                                "
                                            >
                                                {{ productClass.Description }}
                                            </div>
                                        </div>
                                        <!-- 按鈕 -->
                                        <div class="pcat-page__card-actions">
                                            <template
                                                v-if="
                                                    productClass.OnlineEditURL !==
                                                        '' &&
                                                    productClass.OnlineEditURL !==
                                                        '/Product/Items?type=&size=&binding='
                                                "
                                            >
                                                <a
                                                    class="pcat-page__card-btn pcat-page__card-btn--half"
                                                    :href="
                                                        productClass.OnlineEditURL
                                                    "
                                                >
                                                    線上製作
                                                </a>
                                            </template>
                                            <template
                                                v-if="
                                                    getProductExceptionItem(
                                                        productClass.Type
                                                    )
                                                "
                                            >
                                                <a
                                                    class="pcat-page__card-btn pcat-page__card-btn--full"
                                                    href="/Home/App"
                                                >
                                                    健豪APP下載
                                                </a>
                                                <a
                                                    class="pcat-page__card-btn pcat-page__card-btn--primary"
                                                    :href="
                                                        getDetailUrl(
                                                            productClass.ProductClassID
                                                        )
                                                    "
                                                >
                                                    上傳檔案
                                                </a>
                                            </template>
                                            <template v-else>
                                                <a
                                                    :class="[
                                                        'pcat-page__card-btn',
                                                        productClass.OnlineEditURL !==
                                                            '' &&
                                                        productClass.OnlineEditURL !==
                                                            '/Product/Items?type=&size=&binding='
                                                            ? 'pcat-page__card-btn--half'
                                                            : 'pcat-page__card-btn--full',
                                                    ]"
                                                    :href="
                                                        getPriceCalculator2Url(
                                                            currentMainClassID,
                                                            subMainClass.SubMainClassID,
                                                            productClass.ProductClassID
                                                        )
                                                    "
                                                >
                                                    線上查價
                                                </a>
                                                <a
                                                    class="pcat-page__card-btn pcat-page__card-btn--primary"
                                                    :href="
                                                        '/CoEditionUpload/CoEditionOrderV2?MainClassID=' +
                                                        currentMainClassID +
                                                        '&SubMainClassID=' +
                                                        subMainClass.SubMainClassID +
                                                        '&ProductClassID=' +
                                                        productClass.ProductClassID
                                                    "
                                                >
                                                    交件送印
                                                </a>
                                            </template>
                                        </div>
                                    </template>
                                    <template #list-overlay>
                                        <!-- 按鈕 -->
                                        <div class="pcat-page__card-actions">
                                            <template
                                                v-if="
                                                    productClass.OnlineEditURL !==
                                                        '' &&
                                                    productClass.OnlineEditURL !==
                                                        '/Product/Items?type=&size=&binding='
                                                "
                                            >
                                                <a
                                                    class="pcat-page__card-btn pcat-page__card-btn--half"
                                                    :href="
                                                        productClass.OnlineEditURL
                                                    "
                                                >
                                                    線上製作
                                                </a>
                                            </template>
                                            <template
                                                v-if="
                                                    getProductExceptionItem(
                                                        productClass.Type
                                                    )
                                                "
                                            >
                                                <a
                                                    class="pcat-page__card-btn pcat-page__card-btn--full"
                                                    href="/Home/App"
                                                >
                                                    健豪APP下載
                                                </a>
                                                <a
                                                    class="pcat-page__card-btn pcat-page__card-btn--primary"
                                                    :href="
                                                        getDetailUrl(
                                                            productClass.ProductClassID
                                                        )
                                                    "
                                                >
                                                    上傳檔案
                                                </a>
                                            </template>
                                            <template v-else>
                                                <a
                                                    :class="[
                                                        'pcat-page__card-btn',
                                                        productClass.OnlineEditURL !==
                                                            '' &&
                                                        productClass.OnlineEditURL !==
                                                            '/Product/Items?type=&size=&binding='
                                                            ? 'pcat-page__card-btn--half'
                                                            : 'pcat-page__card-btn--full',
                                                    ]"
                                                    :href="
                                                        getPriceCalculator2Url(
                                                            currentMainClassID,
                                                            subMainClass.SubMainClassID,
                                                            productClass.ProductClassID
                                                        )
                                                    "
                                                >
                                                    線上查價
                                                </a>
                                                <a
                                                    class="pcat-page__card-btn pcat-page__card-btn--primary"
                                                    :href="
                                                        '/CoEditionUpload/CoEditionOrderV2?MainClassID=' +
                                                        currentMainClassID +
                                                        '&SubMainClassID=' +
                                                        subMainClass.SubMainClassID +
                                                        '&ProductClassID=' +
                                                        productClass.ProductClassID
                                                    "
                                                >
                                                    交件送印
                                                </a>
                                            </template>
                                        </div>
                                    </template>
                                </product-card>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <print-toolbar
            v-if="isPrinting"
            :title="currentMainClassTitle"
            :items="selectedPrintItems"
            :is-printing="isPrinting"
            @update-printing="TogglePrintMode"
            @export="AddPrintItem"
            @export-error="ExportErrorAlert"
        ></print-toolbar>
        <gh-notification ref="favoriteNotificationRef"></gh-notification>
    </div>
</template>

<script setup lang="ts">
    import {
        computed,
        onBeforeUnmount,
        onMounted,
        reactive,
        ref,
        watch,
    } from 'vue';
    import {
        getProductMainClassDetail,
        getProductMainClassTree,
        getProductPostProcessingDetail,
    } from '@/api/product-category/products-classification.api';
    import GhBreadcrumb from '@/components/base/GhBreadcrumb.vue';
    import GhModal from '@/components/base/GhModal.vue';
    import GhNotification from '@/components/base/GhNotification.vue';
    import GhSidebar from '@/components/base/GhSidebar.vue';
    import SvgIcon from '@/components/base/SvgIcon.vue';
    import PrintToolbar from '@/components/print/PrintToolbar.vue';
    import ProductCard from '@/components/products/ProductCard.vue';
    import { API_EC } from '@/config/api.config';
    import {
        getProductExceptionItem,
        updateUrlParams,
    } from '@/utils/general.utils';
    import { IMAGE_MODE } from '@/types/components/image-mode.types';
    import { LAYOUT_MODE } from '@/types/components/layout-mode.types';
    import {
        ScrollBehaviorMode,
        SidebarActiveScrollPosition,
        type BreadcrumbNodeItem,
        type SidebarMenuPayload,
    } from '@/types/components/base-components.types';
    import type {
        ClassificationSidebarItem,
        NormalizedProductSubMainClass,
        ProductClass,
        ProductMainClass,
        ProductSubMainClass,
    } from './products-classification.shared';
    import {
        DEFAULT_SUPER_CLASS_ID,
        LEGACY_RGB_PRODUCT_DETAIL_URL,
        CALENDAR_GALLERY_URL,
        buildClassificationSidebarItems,
        formattedNumber,
        formattedPrice,
        getPriceCalculator2Url,
        getProductsClassificationUrl,
        normalizeProductSubMains,
        resolveProductsClassificationInitialState,
    } from './products-classification.shared';

    type GhModalInstance = {
        open: (options?: Record<string, unknown>) => void;
    };

    // ----- state -----
    const initialState = resolveProductsClassificationInitialState();

    // 排列模式，初始為圖示排列
    const currentMode = ref<LAYOUT_MODE>(LAYOUT_MODE.GRID);
    const currentMainClassID = ref(initialState.currentMainClassID);
    const currentSubMainID = ref(initialState.currentSubMainClassID);
    // 是否為大類底下第一個中類
    const isFirstSubMainID = ref(false);

    // URL 參數，先以 SSR payload 種入，client 掛載後再依實際網址校正
    const urlQueryString = reactive({
        superClassID: initialState.superClassID,
        mainClassID: initialState.currentMainClassID,
        subMainClassID: initialState.currentSubMainClassID,
        productClassID: '',
        tag: '',
    });

    const hasHandledPriceDialogQuery = ref(false);
    const isPostProcessing = ref(initialState.isPostProcessing);
    const authenticationType = initialState.authenticationType;
    const isAuthorized = initialState.isAuthorized;

    // 左側大類/中類樹狀資料，首屏由 SSR initial state 種入 sidebar
    const productMainClassList = ref<ProductMainClass[]>(
        initialState.productMainClassList
    );
    // #productBoxs 右側中類與小類，首屏由 SSR initial state 種入
    const productSubMains = ref<NormalizedProductSubMainClass[]>(
        normalizeProductSubMains(initialState.productSubMains)
    );

    // banner 與標題，首屏由 SSR initial state 種入
    const mainClassBannerImage = ref(initialState.mainClassBannerImage);
    const currentMainClassTitle = ref(
        `${initialState.productCode} ${initialState.mainClassName}`.trim()
    );
    const currentMainClassDesc = ref(initialState.description);

    // print，狀態由 shared print store 經 PrintUtils 提供
    const isPrinting = ref(window.PrintUtils?.GetPrintStatus() ?? false);
    const selectedPrintItems = ref(window.PrintUtils?.GetPrintItems() ?? []);
    const selectAllActiveFlag = ref(false);
    const selectNoneActiveFlag = ref(false);

    // gh-modal 動態 refs，依中類索引存取
    const specModalRefs: Record<number, GhModalInstance> = {};
    const priceModalRefs: Record<number, GhModalInstance> = {};
    const specModalRefSetters: Record<number, (el: unknown) => void> = {};
    const priceModalRefSetters: Record<number, (el: unknown) => void> = {};
    const favoriteNotificationRef = ref<unknown>(null);

    // scroll 節流計時器與監聽器，client 掛載期間使用
    let scrollThrottleTimer: number | null = null;
    let boundScrollHandler: (() => void) | null = null;

    // ----- computed -----
    const breadcrumbNodes = computed<BreadcrumbNodeItem[]>(() => [
        {
            name: '商品總覽',
            url: '/ProductCategory',
        },
        {
            name: currentMainClassTitle.value,
            url: '',
        },
    ]);

    // Sidebar 資料來源，統一轉成 gh-menu 固定欄位
    const classificationSidebarItems = computed<ClassificationSidebarItem[]>(
        () => buildClassificationSidebarItems(productMainClassList.value)
    );

    // Sidebar active 狀態：優先高亮目前中類，否則高亮目前大類
    const classificationSidebarActiveId = computed(() => {
        return hasActiveSubMainInCurrentMain()
            ? currentSubMainID.value
            : currentMainClassID.value;
    });

    // activeId 對應層級：0=主類, 1=中類
    const classificationSidebarActiveLevel = computed(() => {
        return hasActiveSubMainInCurrentMain() ? 1 : 0;
    });

    const btnStyle = computed(() => ({
        padding: '4px 12px',
        'border-radius': '100px',
        'line-height': '1.5rem',
    }));

    // 是否顯示 VIP 價格表 (會員類別為 2)
    const isVipPricing = computed(() => authenticationType === '2');

    // ----- methods -----
    // Sidebar 點擊事件：跨 MainClass 交由 MVC route 整頁導向；同 MainClass 前端畫面滾動
    const handleClassificationSidebarChange = (
        payload: SidebarMenuPayload
    ): void => {
        const itemId = payload?.itemId != null ? String(payload.itemId) : '';
        if (!itemId) {
            return;
        }

        const superClassID = urlQueryString.superClassID || '';
        let mainClassID: string;
        let subMainClassID = '';

        if (payload.level === 0) {
            // level-0：點擊 MainClass
            mainClassID = itemId;
        } else {
            // level-1：點擊 SubMainClass，透過 activeIdMap 取回所屬 MainClassID
            const activeIdMap = (payload.activeIdMap || {}) as Record<
                string,
                unknown
            >;
            const parentId = activeIdMap['0'];
            mainClassID =
                parentId != null ? String(parentId) : currentMainClassID.value;
            subMainClassID = itemId;
        }

        // 相同 MainClass：資料已載入，僅前端滾動到該 SubMainClass
        if (mainClassID === currentMainClassID.value) {
            if (payload.level === 0) {
                clickMainClass(mainClassID);
            } else {
                clickShowSubMain(subMainClassID, mainClassID);
            }
            return;
        }

        // 跨 MainClass：交由 MVC route 整頁導向，server 重新渲染後由 mounted 讀取路徑參數
        window.location.href = getProductsClassificationUrl(
            superClassID,
            mainClassID,
            subMainClassID
        );
    };

    // 變更產品小類排列方式，並將可視畫面左上角卡片維持在原位置
    const BrowseModeChange = (mode: LAYOUT_MODE): void => {
        const headerHeight = 100 + 65;
        const topLeftCardId = getTopLeftVisibleCard(
            '.product_info_box',
            headerHeight
        );

        currentMode.value = mode;

        if (topLeftCardId) {
            void Promise.resolve().then(() => {
                const el = document.getElementById(topLeftCardId);
                if (!(el instanceof HTMLElement)) return;

                const y = el.getBoundingClientRect().top + window.scrollY;
                window.scrollTo({ top: y - headerHeight, behavior: 'smooth' });
            });
        }
    };

    // 切換列印模式
    const TogglePrintMode = (): void => {
        selectAllActiveFlag.value = false;
        selectNoneActiveFlag.value = false;
        window.PrintUtils?.TogglePrintMode();
    };

    // 輸出商品清單時，儲存勾選項目
    const AddPrintItem = async (): Promise<void> => {
        await window.PrintUtils?.AddPrintItem(API_EC.ADD_REPORT_HISTORY, {
            ContentKey: currentMainClassTitle.value,
            ReportType: 'ProductListPrint',
            ReportContent: JSON.stringify({
                ProductList: selectedPrintItems.value,
            }),
            StorerTypeID: readGlobalString('storerTypeID'),
        });
    };

    // 輸出商品清單錯誤訊息
    const ExportErrorAlert = (msg: string): void => {
        const context = {
            $refs: { printMsgModal: favoriteNotificationRef.value },
        };
        window.PrintUtils?.ExportErrorAlert(
            context as Parameters<
                NonNullable<typeof window.PrintUtils>['ExportErrorAlert']
            >[0],
            msg
        );
    };

    // 檢查列印項目是否勾選
    const IsPrintItemsExists = (productClass: ProductClass): boolean => {
        return window.PrintUtils?.IsPrintItemsExists(productClass) ?? false;
    };

    // 加入/移除列印項目，並依 ProductCode、ProductClassID 排序
    const TogglePrintItem = (productClass: ProductClass): void => {
        window.PrintUtils?.TogglePrintItem(productClass, () => {
            selectedPrintItems.value.sort((a, b) => {
                const codeComparison = String(a.ProductCode).localeCompare(
                    String(b.ProductCode)
                );
                if (codeComparison !== 0) {
                    return codeComparison;
                }
                return String(a.ProductClassID).localeCompare(
                    String(b.ProductClassID)
                );
            });
        });
    };

    // 移除目前勾選的列印項目
    const RemoveAllPrintItem = (): void => {
        selectAllActiveFlag.value = false;
        selectNoneActiveFlag.value = true;
        window.PrintUtils?.RemoveAllPrintItem();
    };

    // 勾選所有列印項目
    const AddAllPrintItem = (
        subMains: NormalizedProductSubMainClass[]
    ): void => {
        selectAllActiveFlag.value = true;
        selectNoneActiveFlag.value = false;
        const tempData = subMains
            .map((item) => item.ProductClassList || [])
            .flat();
        window.PrintUtils?.AddAllPrintItem(tempData);
    };

    // 顯示尺寸規格彈窗
    const showSubMainSpec = (index: number): void => {
        specModalRefs[index]?.open({
            title: '尺寸規格',
            showReject: false,
            width: '1200px',
            isStatic: true,
        });
    };

    // 顯示價格表彈窗 (後加工專用)
    const showSubMainPrice = (index: number): void => {
        if (index < 0) return;
        priceModalRefs[index]?.open({
            title: '價格表',
            showReject: false,
            width: '1200px',
            isStatic: true,
        });
    };

    // 前往商品內容頁
    const goDetail = (productClassId: string): void => {
        window.location.href = getDetailUrl(productClassId);
    };

    // 依會員類別回傳中類對應價格表圖清單
    const getSubMainPricingImages = (
        subMainClass: ProductSubMainClass
    ): string[] => {
        const images = isVipPricing.value
            ? subMainClass.VIPPricingImage
            : subMainClass.NonVIPPricingImage;
        return Array.isArray(images) ? images : [];
    };

    // 取得商品內容頁 url
    const getDetailUrl = (_productClassId: string): string => {
        return LEGACY_RGB_PRODUCT_DETAIL_URL;
    };

    // 點擊左側大類標題，捲回頁首並重新載入該大類明細
    const clickMainClass = (
        mainClassID: string,
        targetSubMainID = ''
    ): void => {
        window.scrollTo({ top: 0, behavior: 'smooth' });

        // 點到同一個 mainClassID 不重新抓
        if (currentMainClassID.value === mainClassID) {
            return;
        }

        currentMainClassID.value = mainClassID;
        currentSubMainID.value = targetSubMainID || '';
        window.PrintUtils?.SetPrintStatus(false);
        window.PrintUtils?.RemoveAllPrintItem();

        void fetchMainClassDetail(mainClassID);
    };

    // 點擊顯示產品中類資訊，同大類滾動、跨大類轉交 clickMainClass
    const clickShowSubMain = (subMainID: string, mainClassID: string): void => {
        if (currentMainClassID.value !== mainClassID) {
            clickMainClass(mainClassID, subMainID);
            return;
        }

        currentSubMainID.value = subMainID;

        if (isFirstSubMainID.value) {
            window.scrollTo({ top: 0, behavior: 'smooth' });
            isFirstSubMainID.value = false;
        } else {
            scrollToSubMainArea(subMainID);
        }
    };

    // 依 URL tag=showprice 自動開啟對應中類價格表
    const openPriceDialogFromUrlQuery = (): void => {
        if (hasHandledPriceDialogQuery.value) {
            return;
        }

        const targetTag = (urlQueryString.tag || '').toLowerCase();
        const targetSubMainClassID = urlQueryString.subMainClassID || '';
        if (targetTag !== 'showprice' || !targetSubMainClassID) {
            hasHandledPriceDialogQuery.value = true;
            return;
        }

        hasHandledPriceDialogQuery.value = true;
        showSubMainPrice(getSubMainPriceIndexById(targetSubMainClassID));
    };

    // 第 1 支 API：依 SuperClassID 取得大類/中類樹狀資料 (左側)
    const fetchMainClassTree = async (): Promise<void> => {
        const requestPostProcessing =
            urlQueryString.superClassID === 'PostProcessing';
        if (requestPostProcessing) {
            isPostProcessing.value = true;
        }

        const res = await getProductMainClassTree(
            urlQueryString.superClassID,
            requestPostProcessing
        );

        if (!res.data.IsSuccess) return;

        productMainClassList.value = res.data.Data.ProductMainClassList || [];

        // URL 帶的 MainClassID 不存在時，預設用第一個
        const found = productMainClassList.value.find(
            (m) => m.MainClassID === urlQueryString.mainClassID
        );
        if (found) {
            currentMainClassID.value = urlQueryString.mainClassID;
        } else if (productMainClassList.value.length > 0) {
            currentMainClassID.value =
                productMainClassList.value[0].MainClassID;
        }

        await fetchMainClassDetail(currentMainClassID.value);
    };

    // 第 2 支 API：取得大類下所有中類與小類 (右側 #productBoxs)
    const fetchMainClassDetail = async (mainClassID: string): Promise<void> => {
        isFirstSubMainID.value = false;

        const res = isPostProcessing.value
            ? await fetchProductPostProcessingDetail(mainClassID)
            : await fetchProductMainClassDetail(mainClassID);

        if (!res.data.IsSuccess) return;

        const data = res.data.Data;
        mainClassBannerImage.value =
            data.MainClassBannerImage || 'default_banner_web.png';

        const mainClassInfo =
            productMainClassList.value.find(
                (m) => m.MainClassID === mainClassID
            ) || ({} as ProductMainClass);
        currentMainClassTitle.value =
            `${mainClassInfo.ProductCode || ''} ${mainClassInfo.MainClassName || ''}`.trim();
        currentMainClassDesc.value = data.Description || '';

        productSubMains.value = normalizeProductSubMains(
            data.ProductSubMainClassList
        );

        // 提供其他頁面使用目前中類清單
        window.PrintUtils?.SendProductSubMains(
            productSubMains.value as unknown as Parameters<
                NonNullable<typeof window.PrintUtils>['SendProductSubMains']
            >[0]
        );

        // URL 帶的 SubMainClassID 無效時，預設用第一個
        const found = productSubMains.value.find(
            (s) => s.SubMainClassID === currentSubMainID.value
        );
        if (!found) {
            currentSubMainID.value =
                productSubMains.value.length > 0
                    ? productSubMains.value[0].SubMainClassID
                    : '';
        }
        if (
            productSubMains.value.length > 0 &&
            currentSubMainID.value === productSubMains.value[0].SubMainClassID
        ) {
            isFirstSubMainID.value = true;
        }

        // 等資料更新、DOM 重繪後再初始化滾動監聽與定位
        void Promise.resolve().then(() => {
            initializeScrollLogic();
            if (currentSubMainID.value) {
                clickShowSubMain(currentSubMainID.value, mainClassID);
            }
            openPriceDialogFromUrlQuery();
        });
    };

    // 取得產品大類明細 (經 MVC route)
    const fetchProductMainClassDetail = (mainClassID: string) => {
        return getProductMainClassDetail(mainClassID);
    };

    // 取得後加工產品明細 (直連 EC)
    const fetchProductPostProcessingDetail = (mainClassID: string) => {
        return getProductPostProcessingDetail(mainClassID);
    };

    // 解析 URL 路徑與 query 參數，路徑優先、其次 query、最後預設值
    const parseUrlParams = (): void => {
        const urlParams = new URLSearchParams(window.location.search);

        const pathSegments = window.location.pathname
            .split('/')
            .filter(Boolean);
        const classificationIndex = pathSegments.findIndex(
            (segment) => segment.toLowerCase() === 'productsclassification'
        );
        const pathSuperClassID =
            classificationIndex >= 0
                ? decodeURIComponent(
                      pathSegments[classificationIndex + 1] || ''
                  )
                : '';
        const pathMainClassID =
            classificationIndex >= 0
                ? decodeURIComponent(
                      pathSegments[classificationIndex + 2] || ''
                  )
                : '';

        urlQueryString.superClassID =
            pathSuperClassID ||
            urlParams.get('SuperClassID') ||
            DEFAULT_SUPER_CLASS_ID;
        urlQueryString.mainClassID =
            pathMainClassID || urlParams.get('MainClassID') || '';
        urlQueryString.subMainClassID = urlParams.get('SubMainClassID') || '';
        urlQueryString.productClassID = urlParams.get('ProductClassID') || '';
        urlQueryString.tag = urlParams.get('tag') || '';

        currentMainClassID.value = urlQueryString.mainClassID;
        currentSubMainID.value = urlQueryString.subMainClassID;
        isPostProcessing.value = false;
    };

    // 滾輪滑動時切換 header/側欄固定狀態，並依位置高亮對應中類
    const initializeScrollLogic = (): void => {
        if (boundScrollHandler) return;

        const mainSubmainContent =
            document.getElementById('MainSubmainContent');
        const navViewsContent = document.getElementById('NavViewsContent');

        boundScrollHandler = () => {
            if (scrollThrottleTimer) return;
            scrollThrottleTimer = window.setTimeout(() => {
                scrollThrottleTimer = null;
            }, 100);

            const scrollPosition =
                window.scrollY || document.documentElement.scrollTop;

            toggleElementVisible('.back-to-top', scrollPosition > 150);

            const headerArea = document.querySelector('.header_area1');
            const mainMenu = document.querySelector('.mainmenu');
            if (scrollPosition > 80) {
                // 非手機畫面才隱藏 header
                if (!document.body.classList.contains('mobile')) {
                    toggleElementVisible('.header_area1', false, headerArea);
                }
                mainMenu?.classList.add('fixed_top');
                mainSubmainContent?.classList.add('is-fixed');
                navViewsContent?.classList.add('is-fixed');
            } else {
                toggleElementVisible('.header_area1', true, headerArea);
                mainMenu?.classList.remove('fixed_top');
                mainSubmainContent?.classList.remove('is-fixed');
                navViewsContent?.classList.remove('is-fixed');
            }

            // 依滾動位置高亮對應中類
            document
                .querySelectorAll('.pcat-page__section-anchor')
                .forEach((area) => {
                    if (!(area instanceof HTMLElement)) return;
                    const areaTop = area.offsetTop;
                    const areaHeight = area.offsetHeight;
                    const areaId = area.id.replace('SubMainArea_', '');

                    if (
                        scrollPosition >= areaTop &&
                        scrollPosition <= areaTop + areaHeight &&
                        currentSubMainID.value !== areaId
                    ) {
                        currentSubMainID.value = areaId;
                    }
                });
        };

        window.addEventListener('scroll', boundScrollHandler);
    };

    // 找出目前可視畫面最左上角的商品卡片 id
    const getTopLeftVisibleCard = (
        cardSelector: string,
        headerHeight: number
    ): string | null => {
        let topLeftCard: HTMLElement | null = null;
        let minDistance = Infinity;

        document.querySelectorAll(cardSelector).forEach((card) => {
            if (!(card instanceof HTMLElement)) return;
            const rect = card.getBoundingClientRect();
            const offsetTop = rect.top;
            const offsetLeft = rect.left;

            if (
                offsetTop < headerHeight ||
                offsetTop >= document.documentElement.clientHeight
            ) {
                return;
            }
            if (
                offsetLeft < 0 ||
                offsetTop >= document.documentElement.clientWidth
            ) {
                return;
            }

            const distance = offsetTop * offsetTop + offsetLeft * offsetLeft;
            if (distance < minDistance) {
                minDistance = distance;
                topLeftCard = card;
            }
        });

        return topLeftCard ? (topLeftCard as HTMLElement).id : null;
    };

    // 判斷目前大類底下是否有選中的中類
    const hasActiveSubMainInCurrentMain = (): boolean => {
        const currentMain = productMainClassList.value.find(
            (mainClass) => mainClass.MainClassID === currentMainClassID.value
        );
        const currentSubMainList =
            currentMain && Array.isArray(currentMain.ProductSubMainClassList)
                ? currentMain.ProductSubMainClassList
                : [];
        return currentSubMainList.some(
            (subMainClass) =>
                subMainClass.SubMainClassID === currentSubMainID.value
        );
    };

    // 依中類 ID 對應目前畫面資料的價格表索引
    const getSubMainPriceIndexById = (subMainClassId: string): number => {
        return productSubMains.value.findIndex(
            (subMainClass) =>
                String(subMainClass.SubMainClassID) === String(subMainClassId)
        );
    };

    // 滾動到對應的中類區塊
    const scrollToSubMainArea = (subMainID: string): void => {
        const subMainElement = document.getElementById(
            `SubMainArea_${subMainID}`
        );
        if (!(subMainElement instanceof HTMLElement)) return;

        const navViewsContent = document.getElementById('NavViewsContent');
        const hasTopFixed =
            navViewsContent?.classList.contains('is-fixed') ?? false;
        // 麵包屑固定頂部減 180，原始位置減 230
        const minusVal = hasTopFixed ? 180 : 230;
        const y = subMainElement.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: y - minusVal, behavior: 'smooth' });
    };

    // 滾動到對應的小類區塊
    const scrollToProductInfoBox = (productID: string): void => {
        const productInfoBoxElement = document.getElementById(
            `ProductInfoBox_${productID}`
        );
        if (!(productInfoBoxElement instanceof HTMLElement)) return;

        const navViewsContent = document.getElementById('NavViewsContent');
        const hasTopFixed =
            navViewsContent?.classList.contains('is-fixed') ?? false;
        const minusVal = hasTopFixed ? 180 : 230;
        const y =
            productInfoBoxElement.getBoundingClientRect().top + window.scrollY;
        window.scrollTo({ top: y - minusVal, behavior: 'smooth' });
    };

    // 執行 PrintUtils.SetPrintStatus / TogglePrintMode 後同步列印狀態
    const UpdatePrintStatus = (): void => {
        isPrinting.value = window.PrintUtils?.GetPrintStatus() ?? false;

        if (isPrinting.value) {
            // 列印模式強制切回圖示排列
            currentMode.value = LAYOUT_MODE.GRID;
        } else {
            RemoveAllPrintItem();
        }
    };

    // 同步目前勾選列印項目
    const UpdatePrintItems = (): void => {
        selectedPrintItems.value = window.PrintUtils?.GetPrintItems() ?? [];
    };

    // 更新全選/取消全選狀態
    const SelectActiveHandler = (): void => {
        const totalProductLength = productSubMains.value.reduce(
            (sum, item) => sum + (item.ProductClassList?.length || 0),
            0
        );
        selectAllActiveFlag.value =
            selectedPrintItems.value.length === totalProductLength;
        selectNoneActiveFlag.value = selectedPrintItems.value.length === 0;
    };

    // 依索引回傳穩定的尺寸規格彈窗 ref setter，避免每次渲染產生新函式造成 ref 反覆註冊
    const getSpecModalRefSetter = (index: number) => {
        if (!specModalRefSetters[index]) {
            specModalRefSetters[index] = (el: unknown) => {
                if (el) {
                    specModalRefs[index] = el as GhModalInstance;
                } else {
                    delete specModalRefs[index];
                }
            };
        }
        return specModalRefSetters[index];
    };

    // 依索引回傳穩定的價格表彈窗 ref setter
    const getPriceModalRefSetter = (index: number) => {
        if (!priceModalRefSetters[index]) {
            priceModalRefSetters[index] = (el: unknown) => {
                if (el) {
                    priceModalRefs[index] = el as GhModalInstance;
                } else {
                    delete priceModalRefs[index];
                }
            };
        }
        return priceModalRefSetters[index];
    };

    // 顯示/隱藏元素，取代 legacy jQuery fadeIn/fadeOut
    const toggleElementVisible = (
        selector: string,
        visible: boolean,
        cachedElement?: Element | null
    ): void => {
        const element = cachedElement ?? document.querySelector(selector);
        if (!(element instanceof HTMLElement)) return;
        element.style.display = visible ? '' : 'none';
    };

    // 讀取 window 上 inline script 注入的字串全域值
    const readGlobalString = (key: string): string => {
        const value = (window as unknown as Record<string, unknown>)[key];
        return typeof value === 'string' ? value : '';
    };

    // 瀏覽桌月曆圖庫
    const goCalendar = (): string => {
        return CALENDAR_GALLERY_URL;
    };

    // ----- watch -----
    // currentSubMainID 變更時防抖同步 SubMainClassID 至 query，避免覆寫路徑
    let urlSyncTimer: number | null = null;
    watch(currentSubMainID, () => {
        if (window.__GH_SSR_MODE__) return;
        if (urlSyncTimer) {
            window.clearTimeout(urlSyncTimer);
        }
        urlSyncTimer = window.setTimeout(() => {
            updateUrlParams({ SubMainClassID: currentSubMainID.value });
        }, 300);
    });

    // ----- lifecycle -----
    onMounted(() => {
        // SSR pre-render 期間僅輸出 initial state 首屏，不執行 client 端資料抓取與副作用
        if (window.__GH_SSR_MODE__) {
            return;
        }

        parseUrlParams();

        window.addEventListener('UpdatePrintStatus', UpdatePrintStatus);
        window.addEventListener('UpdatePrintItems', UpdatePrintItems);
        window.addEventListener('SelectActiveHandler', SelectActiveHandler);

        fetchMainClassTree()
            .then(() => {
                void Promise.resolve().then(() => {
                    if (window.location.hash) {
                        scrollToSubMainArea(
                            window.location.hash.replace(/#/g, '')
                        );
                    } else if (urlQueryString.productClassID) {
                        scrollToProductInfoBox(urlQueryString.productClassID);
                    }
                });
            })
            .catch((err) => {
                console.error('fetchMainClassTree error:', err);
            });
    });

    onBeforeUnmount(() => {
        window.removeEventListener('UpdatePrintStatus', UpdatePrintStatus);
        window.removeEventListener('UpdatePrintItems', UpdatePrintItems);
        window.removeEventListener('SelectActiveHandler', SelectActiveHandler);
        if (boundScrollHandler) {
            window.removeEventListener('scroll', boundScrollHandler);
            boundScrollHandler = null;
        }
    });
</script>

<style lang="scss" scoped>
    @use '@/assets/styles/components/PcatPage.shared.scss' as pcat;

    @include pcat.pcatPageShared();

    .pcat-page {
        width: 100%;

        &[v-cloak] {
            display: block;
            visibility: hidden;
        }

        &__sidebar-col {
            width: 288px;
            min-width: 10rem;
            margin-top: 1.2%;
        }

        &__sidebar-shell {
            position: relative;
            width: 100%;
            max-width: 288px;
            font-size: 1rem;
            color: $textColor888;

            &.is-fixed {
                position: fixed;
                width: inherit;
                margin-top: -3rem;
            }
        }

        &__sidebar-panel {
            padding: 1rem 0.5rem;
            border: 1px solid $grayColorE7;
            border-radius: 8px;
            height: 30rem;
            max-height: 500px;

            > div {
                height: 100%;
                overflow: hidden;
            }
        }

        &__sidebar {
            height: 100%;
            padding: 0;

            :deep(.gh-menu__list--level-0) {
                padding-right: 8px;
            }

            :deep(.gh-menu__list--level-1) {
                padding-left: 1.5rem;
            }

            :deep(.gh-menu__item:active > .gh-menu__link),
            :deep(.gh-menu__item.is-active > .gh-menu__link),
            :deep(.gh-menu__item.is-expanded > .gh-menu__link) {
                color: $blueColor_2C94FF;
                background-color: initial;

                > .gh-menu__code {
                    background-color: #eff6ff;
                    color: $blueColor_2C94FF;
                }
            }

            :deep(.gh-menu__item > .gh-menu__link:hover) {
                color: $blueColor_2C94FF;
                background-color: $blueColor_EFF6FF;

                > .gh-menu__code {
                    color: $blueColor_2C94FF;
                    background-color: #fff;
                }
            }

            :deep(.gh-menu__link) {
                padding: 4px 8px;
                border: 0;
            }

            :deep(.gh-menu__code) {
                font-size: 0.88rem;
            }

            :deep(.gh-menu__name) {
                font-size: 1rem;
                line-height: 1.5rem;
            }
        }

        &__links {
            padding: 1.5rem 2rem 0;

            li {
                margin-bottom: 1rem;

                &:hover {
                    color: $blueColor_2C94FF;
                }
            }
        }

        &__content-col {
            width: calc(100% - 288px);
            margin-top: 1.2%;
            padding-left: 2%;
            float: right;
            position: relative;
        }

        &__banner {
            position: relative;
            width: 100%;
            margin-bottom: 1.5rem;
        }

        &__banner-media {
            position: relative;
            aspect-ratio: 111 / 38;

            img {
                width: 100%;
                height: 100%;
                object-fit: cover;
                border-radius: 8px;
            }
        }

        &__banner-card {
            width: 35%;
            min-width: 296px;
            position: absolute;
            top: 0;
            bottom: 0;
            margin: auto;
            margin-left: 5%;
            display: flex;
            align-items: center;
        }

        &__banner-body {
            border-radius: 8px;
            background-color: #fff;
            padding: 1rem;
            min-height: 130px;
        }

        &__banner-title {
            display: block;
            font-size: 1.25rem;
            font-weight: normal;
            color: $textColor45;
            margin-top: 0;
            margin-bottom: 0.4rem;
        }

        &__banner-desc {
            font-size: 0.88rem;
            line-height: 1.3;
            color: $textColor888;
            text-align: justify;
            margin: 0;
        }

        &__nav {
            position: relative;
            display: flex;
            gap: 0.5rem;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1.5rem;
            flex-wrap: wrap;

            &.is-fixed {
                position: fixed;
                margin: 0;
                top: 6rem;
                padding: 1rem 0;
                width: 888px;
                background-color: $bg-gray-light-FD;
                z-index: 5;
            }
        }

        &__breadcrumb {
            flex: 1;
            min-width: 0;

            :deep(.gh-breadcrumb__outer) {
                width: 100%;
            }

            :deep(.gh-breadcrumb__content) {
                margin: 0;
            }
        }

        &__layout {
            margin: 0 0.2rem 0 1rem;
            display: flex;
            justify-content: flex-end;
            gap: 0 0.5rem;
        }

        &__layout-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            position: relative;
            text-decoration: none;
            color: $textColor888;
            background-color: #fff;
            padding: 4px 8px;
            min-width: 102px;
            width: 6.5rem;
            border-radius: 100px;
            border: 1px solid $grayColorB0;

            > span {
                height: 1rem;
                line-height: 1rem;
            }

            &:hover {
                background-color: $blueColor_EFF6FF;
                border-color: #91c3ff;
            }

            &.is-current,
            &:active {
                cursor: default;
                color: #fff;
                background-color: $blueColor_2C94FF;
                border: 1px solid $grayColorE7;
            }

            &--auto {
                width: auto;
                white-space: nowrap;
            }
        }

        &__layout-separator {
            width: 1px;
            background-color: $grayColorD1;
            margin: 0 0.25rem;
        }

        &__sections {
            position: relative;
            width: 100%;
        }

        &__section {
            position: relative;
            width: 100%;
            margin-bottom: 3rem;
        }

        &__section-head {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 1rem;
        }

        &__products {
            :deep(.gh-product-card__image-wrapper) {
                position: relative;
                width: 100%;
                aspect-ratio: 1 / 1;
                box-sizing: border-box;
            }

            :deep(.gh-product-card__overlay) {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                display: flex;
                opacity: 0;
                transition: opacity 0.3s ease-in-out;
                flex-direction: column;
                z-index: 4;
            }

            :deep(
                .gh-product-card__image-wrapper:hover .gh-product-card__overlay
            ) {
                opacity: 1;
            }

            :deep(.gh-product-card__desc-detailed) {
                position: relative;
                font-size: 0.88rem;
                color: $textColor888;
                margin-top: 0.5rem;
                text-align: justify;
                display: none;
            }

            :deep(.gh-product-card__desc-detailed.is-post-processing-desc) {
                display: block;
            }
        }

        &__products--grid {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            gap: 0 24px;

            :deep(.gh-product-card) {
                flex: 0 0 calc((100% - 24px * 2) / 3);
            }

            :deep(.gh-product-card:nth-child(n + 4)) {
                margin-top: 2%;
            }

            :deep(.gh-product-card__overlay) {
                background-color: rgba(0, 0, 0, 0.6);
            }
        }

        &__products--list {
            :deep(.gh-product-card) {
                width: 100%;
                border: 1px solid $grayColorE7;
                border-radius: 8px;
                background-color: #fff;
                margin-bottom: 1rem;
                padding: 1rem;
                position: relative;
                display: flex;
            }

            :deep(.gh-product-card__image-wrapper) {
                width: 25%;
                position: static;
                margin-bottom: 0;
            }

            :deep(.gh-product-card__overlay) {
                background-color: unset;
                opacity: 1;
                pointer-events: auto;
                z-index: 9;
            }

            :deep(.gh-product-card__overlay--list) {
                width: 20%;
                left: auto;
                right: 1rem;
            }

            .pcat-page__card-actions {
                width: 100%;
                padding: 1rem 0;
                display: flex;
                flex-direction: column;
                gap: 0.5rem;
                flex: 0;
            }

            .pcat-page__card-btn--half {
                width: 100%;
            }

            .pcat-page__card-btn--primary {
                margin-top: auto;
            }

            :deep(.gh-product-card__info) {
                width: 75%;
                padding-left: 1rem;
                display: flex;
                flex-direction: column;
            }

            :deep(.gh-product-card__desc) {
                width: 70%;
            }

            :deep(.gh-product-card__desc-detailed) {
                width: 70%;
                position: relative;
                font-size: 0.88rem;
                color: #969696;
                margin-top: 0.5rem;
                margin-bottom: 1rem;
                text-align: justify;
                display: block;
            }

            :deep(.gh-product-card__desc-detailed.is-post-processing-desc) {
                width: 95%;
            }

            :deep(.gh-product-card__price-area) {
                margin-top: auto;
                display: block;
                width: 97%;
                padding-top: 1rem;
                border-top: 1px solid $grayColorE7;
            }

            .pcat-page__price-grid {
                display: none;
            }

            .pcat-page__price-list {
                display: inline-flex;
            }
        }

        :deep(.spec-modal .gh-modal-header),
        :deep(.price-modal .gh-modal-header) {
            padding: 1rem;
            font-size: 1.5rem;
            line-height: 1.5rem;
        }
    }

    @include rwd($fullHD) {
        .pcat-page {
            &__sidebar-col {
                width: 240px;
            }

            &__content-col {
                width: calc(100% - 240px);
            }

            // 使用 content_outer 寬度扣除
            .pcat-page__nav.is-fixed {
                width: calc(1000px - 240px - 2% + 4px);
            }
        }
    }

    @include rwd($contentOuterHD) {
        .pcat-page {
            // 使用 content_outer 寬度扣除
            .pcat-page__nav.is-fixed {
                width: calc(80% - 240px - 2% + 4px);
            }
        }
    }

    @include rwd($pc) {
        .pcat-page {
            &__sidebar-col {
                width: 230px;
            }

            &__content-col {
                width: calc(100% - 230px);
            }

            // 使用 content_outer 寬度扣除
            .pcat-page__nav.is-fixed {
                width: calc(90% - 230px - 2% + 4px);
            }
        }
    }

    @include rwd($pc - 100) {
        .pcat-page {
            &__sidebar-col {
                width: 220px;
            }

            &__content-col {
                width: calc(100% - 220px);
            }

            // 使用 content_outer 寬度扣除
            .pcat-page__nav.is-fixed {
                width: calc(90% - 220px - 2% + 4px);
            }
        }
    }

    @include rwd($pad) {
        .pcat-page {
            &__sidebar-col {
                width: 200px;
                margin-top: 1.5%;
            }

            &__content-col {
                width: calc(100% - 200px);
                margin-top: 1.5%;
            }

            // 使用 content_outer 寬度扣除
            .pcat-page__nav.is-fixed {
                width: calc(100% - 200px);
            }

            &__banner-body {
                min-height: unset;
            }

            &__nav {
                margin: 1rem 0;
                gap: 0.5rem;
            }

            &__breadcrumb,
            &__layout {
                width: 100%;
            }

            &__layout {
                margin: 0 1rem 0 0;
            }

            &__section-head {
                align-items: unset;
                margin-bottom: 0.5rem;
                flex-direction: column;
            }

            &__section-actions {
                justify-content: flex-end;
            }

            &__products--grid {
                :deep(.gh-product-card) {
                    flex-basis: 48%;
                }
            }

            &__products--list {
                :deep(.gh-product-card__image-wrapper) {
                    width: 0%;
                }

                :deep(.gh-product-card) {
                    padding: 0.7rem;
                }

                :deep(.gh-product-card__overlay--list) {
                    width: 26%;
                    right: 0;
                }

                :deep(.gh-product-card__info) {
                    width: 100%;
                    padding-left: unset;
                }

                :deep(.gh-product-card__price-area) {
                    margin-top: 6%;
                    position: relative;

                    img {
                        display: none;
                    }
                }
            }
        }
    }

    @include rwd($mobile) {
        .pcat-page {
            &__nav.is-fixed {
                top: 2rem;
                padding-top: 2rem;
            }
        }
    }

    @include rwd($mobileM - 50) {
        .pcat-page {
            &__sidebar-col {
                width: 150px;
                margin-top: 1.5%;
            }

            &__content-col {
                width: calc(100% - 150px);
                margin-top: 1.5%;
            }

            .pcat-page__nav.is-fixed {
                width: calc(100% - 150px);
            }

            &__sidebar {
                :deep(.gh-menu__code) {
                    text-align: center;
                }

                :deep(.gh-menu__link--level-1) {
                    flex-direction: column;
                    align-items: flex-start;
                }
            }

            &__banner-card {
                width: 80%;
                min-width: unset;
                margin-left: auto;
            }

            &__products--grid {
                :deep(.gh-product-card) {
                    flex-basis: 100%;
                }
            }

            &__products--list {
                :deep(.gh-product-card) {
                    padding: 0.5rem;
                }

                :deep(.gh-product-card__overlay--list) {
                    width: 30%;
                    right: 0;
                }
            }
        }
    }
</style>
